<template>
  <div class="cards-sidebar">
    <SidebarItem
      v-for="(card, index) in sidebarCards"
      :key="index"
      class="sidebar-item"
      :title="card.title"
      :index="index"
      @click-sidebar-item="$emit('clickSidebarItem', index)"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import SidebarItem from './CardsSidebarItem.vue';

  export default defineNuxtComponent({
    name: 'CardsSidebar',
    components: {
      SidebarItem,
    },

    props: {
      sidebarCards: {
        required: true,
        type: Array as PropType<Array<Record<string, string | number>>>,
      },
    },

    emits: ['clickSidebarItem'],
  });
</script>

<style lang="scss" scoped>
  .cards-sidebar {
    :deep() {
      .cards-sidebar-item:not(:first-child) {
        margin-top: $spacing-3;
      }
    }
  }
</style>
